// extracted by mini-css-extract-plugin
export default {"section":"zlmZM","title":"rJyhH","text":"RX_QL DS0GQ","mapWithPopup":"GXsty","mapPlaceholder":"ocZzQ"};